import { BerthResponse } from '@yard/app/api'
import { PierStore } from '@yard/stores/pier.store'
import { action, computed, makeObservable } from 'mobx'
import { BerthStore } from '../../../../stores/berth.store'
import {
  mapBerthFormDataToCreateCommand,
  mapBerthFormDataToUpdateCommand,
} from '../../helpers/berth.mapper'
import { IBerthFormData } from '../../models/yard-setup.model'
import { YardNodeViewStore } from './yard-node.view-store'

export class BerthViewStore extends YardNodeViewStore<IBerthFormData, BerthStore> {
  constructor(
    berthStore: BerthStore,
    private readonly pierStore: PierStore,
  ) {
    super(berthStore)
    makeObservable(this, {
      setPosition: action,
      focusedBerth: computed,
      piers: computed,
    })
  }

  setPosition = (id: string, position: { x: number; y: number }) => {
    const berth = this.entityStore.items.find(b => b.id === id)

    if (berth && (berth.layoutPosition.x !== position.x || berth.layoutPosition.y !== position.y)) {
      this.entityStore.updateBerth({
        ...berth,
        layoutPosition: {
          ...berth.layoutPosition,
          x: Math.round(position.x),
          y: Math.round(position.y),
        },
      })
    }
  }

  setRotation = (id: string, rotation: number) => {
    const berth = this.entityStore.berths[id]

    if (berth && berth.layoutPosition.rotation !== rotation) {
      const layoutPosition = {
        ...berth.layoutPosition,
        rotation: Math.round(rotation),
      }

      this.entityStore.updateBerth({
        ...berth,
        layoutPosition,
      })
    }
  }

  get focusedBerth(): BerthResponse | undefined {
    return this.editingId ? this.entityStore.berths[this.editingId] : undefined
  }

  get piers() {
    return this.pierStore.items
  }

  async submit(formData: IBerthFormData): Promise<void> {
    if (this.editingId) {
      const updateCommand = mapBerthFormDataToUpdateCommand(formData, this.focusedBerth!)

      await this.entityStore.updateBerth(updateCommand)
    } else {
      const createCommand = mapBerthFormDataToCreateCommand(formData, this.viewportCenter)

      await this.entityStore.addBerth(createCommand)
    }
  }

  async delete(id: string): Promise<void> {
    await this.entityStore.deleteBerth(id)
  }
}
